(function () {
    'use strict';

    angular
        .module('cog.shared')
        .factory('customerGameSelection', CustomerGameSelection);

    function CustomerGameSelection(accountService: IAccountService, BET_TYPES, $window, $rootScope, lineFormater, notificationService: INotificationService, $mdDialog, $state, $q) {
        var sportSelections = { Clear: Clear, Toggle: Toggle, Add: Add, Items: [], UrlKey: UrlKey, _indexOfObject: _indexOfObject, GetSelectionList: GetSelectionList };
        var gameSelections = { Clear: ClearGame, Add: AddGame, Remove: RemoveGame, Items: [], ToWager: ToWager, SetBetAmount: SetBetAmount, Swap: SwapGame, AmountChange: AmountChange, GetBetAmount: GetBetAmount, SetWinPush: SetWinPush, SetFreePlay: SetFreePlay, GetFreePlay: GetFreePlay, RoundRobins: [], AddRR: addRR, ChangeAmtRR: chgAmtRR, ClearRR: clearRR, fillSpotToWager: fillSpotToWager, setCalcType: setCalcType, getCalcType: getCalcType, getGameCalc: getGameSelCalc, setGameCalc: setGameSelCalc, RiskChange: RiskChange, WinChange: WinChange, PointsTxtChange: PointsTxtChange, UpdatePitcherSelection: UpdatePitcherSelection };
        var parlayLimits: ICustomerParlayLimit = { set: setParlayLimits, get: getParlayLimits, allowParlay: allowParlay, data: null, parlayMaxTeams: parlayMaxTeams, validParlayTeams: validParlayTeams, parlayMaxBet: parlayMaxBet, parlayTeamsMaxBet: parlayTeamsMaxBet };
        var teaserLimits: ICustomerTeaserLimit = { set: setTeaserLimits, get: getTeaserLimits, allowTeaser: allowTeaser, data: null, maxTeams: teaserMaxTeams, maxBet: teaserMaxBet, maxProfileTeams: teaserProfileMaxTeams, minProfileTeams: teaserProfileMinTeams };
        var ifbetLimits: ICustomerIfbetLimit = { set: setIfbetLimits, get: getIfbetLimits, allowIfbet: allowIfbet, data: null, ifbetMaxBet: ifbetMaxBet, ifbetMaxTeams: ifbetMaxTeams, allowIffers: allowIffers };
        var actionReverseLimits: ICustomerActionReverseLimit = { set: setActionReverseLimits, get: getActionReverseLimits, allowActionReverse: allowActionReverse, data: null, actionReverseMaxBet: actionReverseMaxBet, actionReverseMaxTeams: actionReverseMaxTeams, actionReverseGetTeamsProfile: actionReverseGetTeamsProfile };
        var pitcherSelection: ICustomerPitcherSelection = { settings: null, getSettings: getPitcherSettings, setSettings: setPitcherSettings };
        var betAmount = 0; // used for parlay & teasers
        var customerAvailableOptions: ICustomerAvailableOptions = { set: setCustomerAvalableOptions, get: getCustomerAvalableOptions, data: null, FreePlayAmount: 0, setFreePlayAmt: setFreePlayAmt, setCommPermissions: setCommPermissions, getCommPermissions: getCommPermissions, dataCommPerm: null };
        var winpush: boolean = false;
        var openSpots: ICustomerOpenSpots = { allowOpenSpots: allowOpenSpots, maxOpenSpots: maxOpenSpots, getOpenSpots: getOpenSpots, setOpenSpots: setOpenSpots, addOpenSpot: addOpenSpot, removeOpenSpot: removeOpenSpot, spots: 0, fillSpotData: null, setfillSpotData: setfillSpotData, isFillSpot: false, clearFillSpotData: clearFillSpotData };
        var freePlay: boolean = false;
        var calcType = 'A';

        var factory = {
            sportSelections: sportSelections,
            gameSelections: gameSelections,
            parlayLimits: parlayLimits,
            teaserLimits: teaserLimits,
            ifbetLimits: ifbetLimits,
            actionReverseLimits: actionReverseLimits,
            customerAvailableOptions: customerAvailableOptions,
            resetAll: resetAll,
            getMaxTeamsAllow: getMaxTeamsAllow, // max wager to bet only for Parlay, Action Reverse & Ifbet
            openSpots: openSpots,
            pitcherSelection: pitcherSelection,
            gotoStateConfirm: gotoStateConfirm
        };
        return factory;

        ////////////        

        function Clear() {
            sportSelections.Items.splice(0, sportSelections.Items.length);
        }

        function resetAll() {
            sportSelections.Clear();
            gameSelections.ClearRR();
            openSpots.setOpenSpots(0);
            openSpots.clearFillSpotData(true);
            freePlay = false;
            gameSelections.Clear();
            betAmount = 0;
            customerAvailableOptions.set(null);
            actionReverseLimits.set(null);
            parlayLimits.set(null);
            teaserLimits.set(null);
            ifbetLimits.set(null);
            winpush = false;
            pitcherSelection.setSettings(null);
        }

        function getMaxTeamsAllow(): number {
            var maxAllow = 2;
            var _tp = accountService.getBetSelectionType();
            switch (_tp) {
                case BET_TYPES.P.type:
                case BET_TYPES.B.type:
                    maxAllow = parlayLimits.parlayMaxTeams();
                    break;
                case BET_TYPES.I.type:
                    maxAllow = ifbetLimits.ifbetMaxTeams();
                    break;
                case BET_TYPES.A.type:
                    maxAllow = actionReverseLimits.actionReverseMaxTeams();
                    break;
                case BET_TYPES.T.type:
                    maxAllow = (teaserMaxTeams() != 0 && teaserMaxTeams() < teaserProfileMaxTeams()) ? teaserMaxTeams() : teaserProfileMaxTeams();
                    break;
            }
            return maxAllow;
        }

        //Add if not found, otherwise remove from Items
        function Toggle(item) {
            var idx = sportSelections._indexOfObject(item);
            if (idx == -1) {
                if (item.PeriodNumber == 2) {
                    var start = 0;
                    for (var i = 0; i < sportSelections.Items.length; i++) {
                        if (sportSelections.Items[i].PeriodNumber == 2)
                            start = i + 1;
                    }
                    sportSelections.Items.splice(start, 0, item);

                }
                else
                    sportSelections.Items.push(item);
            }
            else
                sportSelections.Items.splice(idx, 1);
        }

        function UrlKey() {
            var keys = '';
            var _tp = accountService.getBetSelectionType();
            if (_tp == BET_TYPES.T.type) {
                if (sportSelections.Items.length > 0)
                    keys = sportSelections.Items[0].IdSportType.toString();
            } else {
                for (var i = 0, len = sportSelections.Items.length; i < len; i++) {
                    if (i > 0) keys += ",";
                    keys += sportSelections.Items[i].IdSportType.toString() + "_" + sportSelections.Items[i].PeriodNumber.toString();
                }
            }
            return keys;
        }

        //sportSelections.prototype.indexOfObject = function indexOfObject(property, value) {
        function _indexOfObject(value) {
            for (var i = 0, len = sportSelections.Items.length; i < len; i++) {
                if (sportSelections.Items[i].IdSportType == value.IdSportType &&
                    sportSelections.Items[i].PeriodNumber == value.PeriodNumber) return i;
            }
            return -1;
        }

        function Add(key) { // key = idsport_period
            var value = { IdSportType: 0, PeriodNumber: 0 }, idx = key.split('_');
            if (idx.length == 2) {
                value.IdSportType = idx[0]; value.PeriodNumber = idx[1];
                if (value.PeriodNumber == 2)
                    sportSelections.Items.splice(0, 0, value);
                else
                    sportSelections.Items.push(value);
            }
        }

        function GetSelectionList() {
            var arr = [];
             for (var i = 0, len = sportSelections.Items.length; i < len; i++) {
                var scheduleSelectionObject = {IdSport : 0, Period :0};
                scheduleSelectionObject.IdSport= sportSelections.Items[i].IdSportType;
                scheduleSelectionObject.Period = sportSelections.Items[i].PeriodNumber;
                arr.push(scheduleSelectionObject);
            }
            return arr;
        }

        //--gameSelection  Object functions---------------------

        function ClearGame() {
            gameSelections.Items.splice(0, gameSelections.Items.length);
            betAmount = 0;
            openSpots.setOpenSpots(0);
            clearRR();
            clearFillSpotData(false);
        }

        function AddGame(gameSelItemData: IGameSelectionItem) { //(key, amount, lineDetail, period, pitcherData, calcType, lines) {

            var key: string = gameSelItemData.key;
            var amount: number = Number(gameSelItemData.amount);
            if (isNaN(amount)) amount=1;            
            var lineDetail: any = gameSelItemData.lineDetail;
            var period: number = lineFormater.data(key).Period;
            var pitcherData: any = gameSelItemData.pitcherData;
            var calcType: string = gameSelItemData.calcType;
            var lines: ILineObj[] = gameSelItemData.lines;

            var _period = (!isNaN(period) && period >= 0) ? period : 0;
            var idx = _indexOfGameSel(key);
            if (lineDetail.teamLbl == 'Draw')
                lineDetail.teamLbl = lineDetail.teamLbl + " - " + lineDetail.gameLbl;
            if (idx == -1)
                gameSelections.Items.push({ Key: key, Amount: amount, lineDetail: lineDetail, Period: _period, pitcherData: pitcherData, calcType: calcType, lines: lines });
            else {
                /*
                AmountChange(key, amount); // in case amount has changed in BM
                gameSelections.Items[idx].lineDetail = lineDetail; // it comes risk & win val
                */
                // override with curren data
                gameSelections.Items[idx].Key = key;
                gameSelections.Items[idx].Amount = amount;
                gameSelections.Items[idx].lineDetail = lineDetail;
                gameSelections.Items[idx].Period = _period;
                gameSelections.Items[idx].pitcherData = pitcherData;
                gameSelections.Items[idx].calcType = calcType;
                gameSelections.Items[idx].lines = lines;
            }
            openSpots.removeOpenSpot(); // remove open spot
            recalculateOpenSpotAvailable(true);
        }

        function RemoveGame(key) {
            var idx = _indexOfGameSel(key);
            if (idx != -1)
                gameSelections.Items.splice(idx, 1);
            recalculateOpenSpotAvailable(false);
        }

        function UpdatePitcherSelection(pitcherId, pitcherStatus) {
            var arrData = pitcherId.split('_'); //ex p1_1230444
            var gamenum = arrData.length == 2? arrData[1]:0;
            var setVisitorPitcher = arrData.length == 2? arrData[0]=="p1":false;
            for (var i = 0, len = gameSelections.Items.length; i < len; i++) {
                var itm = gameSelections.Items[i];                            
                if (itm.lineDetail.gameId ==  gamenum) {                    
                    if (setVisitorPitcher)
                        itm.pitcherData.p1Selected = pitcherStatus;
                    else
                        itm.pitcherData.p2Selected = pitcherStatus;
                }
            }
        }

        function SwapGame(key, newKey, replace) {
            var idx = _indexOfGameSel(key);
            if (idx != -1) {
                gameSelections.Items[idx].Key = newKey;
                var data = lineFormater.data(newKey);
                if (replace) {
                    var objLine: ILineObj = { Id: newKey, Idx: 0, BuyPoints: data.BuyPoints, Odds: data.Odds, Points: data.Points };
                    gameSelections.Items[idx].lines = [];
                    gameSelections.Items[idx].lines.push(objLine);
                }
            }
        }

        function AmountChange(key, newAmt, calc) {
            var idx = _indexOfGameSel(key);
            if (idx != -1){
                var amount = Number(newAmt);
                if (isNaN(amount)) amount=1;
                gameSelections.Items[idx].Amount = amount;
                gameSelections.Items[idx].calcType = calc;
            }
        }

        function RiskChange(key, newAmt) {
            var idx = _indexOfGameSel(key);
            if (idx != -1 && gameSelections.Items[idx].lineDetail != null) {                
                var amount = Number(newAmt);
                if (isNaN(amount)) amount=1;
                gameSelections.Items[idx].lineDetail.riskVal = amount;
            }
        }

        function WinChange(key, newAmt) {
            var idx = _indexOfGameSel(key);
            if (idx != -1 && gameSelections.Items[idx].lineDetail != null) {
                var amount = Number(newAmt);
                if (isNaN(amount)) amount=1;
                gameSelections.Items[idx].lineDetail.winVal = newAmt;
            }
        }

        function PointsTxtChange(key, newVal) {
            var idx = _indexOfGameSel(key);
            if (idx != -1 && gameSelections.Items[idx].lineDetail != null)
                gameSelections.Items[idx].lineDetail.points = newVal;
        }

        function getGameSelCalc(key) {
            var idx = _indexOfGameSel(key);
            if (idx != -1)
                return gameSelections.Items[idx].calcType;
        }

        function setGameSelCalc(key: string, type: string) {
            var idx = _indexOfGameSel(key);
            if (idx != -1)
                gameSelections.Items[idx].calcType = type;
        }

        function getFirstKey(Key) {
            var arrKey = Key.split('_');
            if (arrKey.length > 7) {
                arrKey.splice(-2);
                Key = arrKey.join('_');
            }
            return Key;
        }

        function _indexOfGameSel(Key) {
            for (var i = 0, len = gameSelections.Items.length; i < len; i++) {
                if (getFirstKey(gameSelections.Items[i].Key) == Key) return i;
            }
            return -1;
        }

        function SetBetAmount(amount: number): void { // for teaser, parlay
            betAmount = 0;
            amount = Number(amount);
            if (!isNaN(amount) && amount > 0) {
                betAmount = amount;
            }
        }

        function GetBetAmount(): number { // for teaser, parlay
            return betAmount;
        }

        function SetWinPush(wp: boolean): void {
            winpush = wp;
        }

        function SetFreePlay(fp: boolean): void {
            freePlay = fp;
        }

        function GetFreePlay(): boolean {
            return freePlay;
        }

        function setCalcType(type: string): void {
            calcType = type;
        }

        function getCalcType(): string {
            return calcType;
        }

        function chkListedPitcher(itm) {
            var formated = lineFormater.data(itm.Key);
            var lineType: string = formated.Type;
            var sData = itm.lineDetail.scheduleData;
            if (sData && pitcherSelection.settings != null && ((pitcherSelection.settings.MoneyLineCode == 1 && lineType == 'M') ||
                (pitcherSelection.settings.TotalCode == 1 && lineType == 'T') || (pitcherSelection.settings.RunlineCode == 1 && lineType == 'S') ||
                sData.Period > 0 || sData.SubSport === 'MLBPlayprops' || sData.SubSport === 'MLB Props' || sData.SubSport === 'MLB Props5' ||
                sData.SubSport === 'MLB Props2' || sData.SubSport === 'CWS Props')) {
                itm.pitcherData.p1Selected = true;
                itm.pitcherData.p2Selected = true;
            } else {
                itm.pitcherData = {
                    p1Selected: false,
                    p2Selected: false
                }
            }
            return itm.pitcherData;
        }

        function ToWager():BetSelContainer { //convert selection to WagerView Object
            var w: BetSelContainer = { Details: [], DelayUntilSignature: "", DelayUntilUTC: ""};            
            var _tp = accountService.getBetSelectionType();
            switch (_tp) {
                case BET_TYPES.S.type:
                case BET_TYPES.E.type:
                    //Period, Id,PicherVisitor,PicherHome
                    for (var i = 0, len = gameSelections.Items.length; i < len; i++) {
                        var sel = gameSelections.Items[i];
                        // BetType send as straight BET_TYPES.S.type even if it is an event
                        var bet: BetSelHeader = { BetType: BET_TYPES.S.type, TotalPicks: 1, IdTeaser: 0, IsFreePlay: freePlay, Amount: sel.Amount, RoundRobinOptions: [], Wagers: [], AmountCalculation: sel.calcType, ContinueOnPush: true };
                        sel.pitcherData = chkListedPitcher(sel);
                        bet.Wagers.push({ Id: sel.Key, PitcherVisitor: sel.pitcherData.p1Selected, PitcherHome: sel.pitcherData.p2Selected });
                        w.Details.push(bet);
                    }
                    break;
                case BET_TYPES.P.type:
                    //var allowOpenSpot: boolean = openSpots.allowOpenSpots();
                    var allowOpenSpot: boolean = allowBetOpenSpots();
                    var os: number = (!allowOpenSpot) ? 0 : openSpots.spots;
                    var pbet:BetSelHeader = { BetType: BET_TYPES.P.type, TotalPicks: (gameSelections.Items.length + os), IdTeaser: 0, IsFreePlay: freePlay, Amount: betAmount, RoundRobinOptions: gameSelections.RoundRobins, Wagers: [], AmountCalculation: calcType, ContinueOnPush: true  };
                    for (var i = 0, len = gameSelections.Items.length; i < len; i++) {
                        var sel = gameSelections.Items[i];
                        sel.pitcherData = chkListedPitcher(sel);
                        pbet.Wagers.push({ Id: sel.Key, PitcherVisitor: sel.pitcherData.p1Selected, PitcherHome: sel.pitcherData.p2Selected });
                    }
                    w.Details.push(pbet);
                    break;
                case BET_TYPES.B.type:
                    var allowOpenSpot: boolean = allowBetOpenSpots();
                    var os: number = (!allowOpenSpot) ? 0 : openSpots.spots;
                    var propbet = { BetType: BET_TYPES.P.type, TotalPicks: (gameSelections.Items.length + os), IdTeaser: 0, IsFreePlay: freePlay, Amount: betAmount, RoundRobinOptions: gameSelections.RoundRobins, Wagers: [], AmountCalculation: calcType, ContinueOnPush: true, PropParlay: true };
                    for (var i = 0, len = gameSelections.Items.length; i < len; i++) {
                        var sel = gameSelections.Items[i];
                        sel.pitcherData = chkListedPitcher(sel);
                        propbet.Wagers.push({ Id: sel.Key, PitcherVisitor: sel.pitcherData.p1Selected, PitcherHome: sel.pitcherData.p2Selected });
                    }
                    w.Details.push(propbet);
                    break;
                case BET_TYPES.T.type:
                    //var allowOpenSpot: boolean = openSpots.allowOpenSpots();
                    var allowOpenSpot: boolean = allowBetOpenSpots();
                    var os: number = (!allowOpenSpot) ? 0 : openSpots.spots;
                    var tbet:BetSelHeader = { BetType: BET_TYPES.T.type, TotalPicks: (gameSelections.Items.length + os), IdTeaser: parseInt(sportSelections.UrlKey()), IsFreePlay: freePlay, Amount: betAmount, RoundRobinOptions: gameSelections.RoundRobins, Wagers: [], AmountCalculation: calcType, ContinueOnPush: true };
                    for (var i = 0, len = gameSelections.Items.length; i < len; i++) {
                        var sel = gameSelections.Items[i];
                        tbet.Wagers.push({ Id: sel.Key, PitcherVisitor: false, PitcherHome: false });
                    }
                    w.Details.push(tbet);
                    break;
                case BET_TYPES.A.type:
                    var abet:BetSelHeader = { BetType: BET_TYPES.A.type, TotalPicks: gameSelections.Items.length, IdTeaser: 0, IsFreePlay: freePlay, Amount: betAmount, RoundRobinOptions: [], Wagers: [], AmountCalculation: calcType, ContinueOnPush: winpush };
                    for (var i = 0, len = gameSelections.Items.length; i < len; i++) {
                        var sel = gameSelections.Items[i];
                        sel.pitcherData = chkListedPitcher(sel);
                        abet.Wagers.push({ Id: sel.Key, PitcherVisitor: sel.pitcherData.p1Selected, PitcherHome: sel.pitcherData.p2Selected });
                    }
                    w.Details.push(abet);
                    break;
                case BET_TYPES.I.type:
                    //Period, Id,PicherVisitor,PicherHome
                    for (var i = 0, len = gameSelections.Items.length; i < len; i++) {
                        var sel = gameSelections.Items[i];
                        var ibet:BetSelHeader = { BetType: BET_TYPES.I.type, TotalPicks: 1, IdTeaser: 0, IsFreePlay: freePlay, Amount: sel.Amount, RoundRobinOptions: [], Wagers: [], AmountCalculation: sel.calcType, ContinueOnPush: winpush };
                        sel.pitcherData = chkListedPitcher(sel);
                        ibet.Wagers.push({ Id: sel.Key, PitcherVisitor: sel.pitcherData.p1Selected, PitcherHome: sel.pitcherData.p2Selected });
                        w.Details.push(ibet);
                    }
                    break;
            }
            return w;
        }

        function fillSpotToWager(): BetSelDetail[] { //convert selection to WagerView Object
            var w: BetSelDetail[] = [];
            var _tp = accountService.getBetSelectionType();
            switch (_tp) {
                case BET_TYPES.P.type:
                case BET_TYPES.B.type:
                    for (var i = 0, len = gameSelections.Items.length; i < len; i++) {
                        var sel = gameSelections.Items[i];
                        sel.pitcherData = chkListedPitcher(sel);
                        var betSel: BetSelDetail = { Id: sel.Key, PitcherVisitor: (sel.pitcherData.p1Selected) ? true : false, PitcherHome: (sel.pitcherData.p2Selected) ? true : false };
                        w.push(betSel);
                    }
                    break;
                case BET_TYPES.T.type:
                    for (var i = 0, len = gameSelections.Items.length; i < len; i++) {
                        var sel = gameSelections.Items[i];
                        w.push({ Id: sel.Key, PitcherVisitor: false, PitcherHome: false });
                    }
                    break;
            }
            return w;
        }

        ////////// PARLAY START ///////////

        function setParlayLimits(pl: IParlayLimit): void {
            parlayLimits.data = pl;
        }

        function getParlayLimits(): IParlayLimit {
            return parlayLimits.data;
        }

        function allowParlay(): boolean {
            var allow = false;
            if (parlayLimits.data != null) {
                allow = parlayLimits.data.AllowParlay;
            }
            return allow;
        }

        function parlayMaxTeams(): number {
            var max = 0;
            if (parlayLimits.data != null) {
                max = parlayLimits.data.ParlayMaxTeams;
            }
            return max;
        }

        function parlayMaxBet(): number {
            var max = 0;
            if (parlayLimits.data != null) {
                max = parlayLimits.data.ParlayMaxBet;
            }
            return max;
        }

        function validParlayTeams(teams: number): boolean {
            var valid = false;
            var max: number = parlayMaxTeams();
            if (max >= teams) {
                var pp: IParlayProfile = $window._.find(parlayLimits.data.ParlayProfile, function (o: IParlayProfile) { return o.Teams == teams });
                if (pp != null) {
                    valid = (pp.Allow) ? true : false;
                } else {
                    var allow = allowBetOpenSpots();
                    if (allow) {
                        valid = true;
                    }
                }
            }
            return valid;
        }

        function parlayTeamsMaxBet(teams: number): number {
            var max = 0;
            var maxteams: number = parlayMaxTeams();
            if (teams >= 2 && maxteams >= teams) {
                var pp: IParlayProfile = $window._.find(parlayLimits.data.ParlayProfile, function (o: IParlayProfile) { return o.Teams == teams });
                if (pp != null)
                    max = pp.MaxBet;
            }
            return max;
        }

        function parlayTeamsMaxOpenSpots(teams: number): number {
            var max = 0;
            var maxteams: number = parlayMaxTeams();
            if (teams >= 1 && maxteams >= teams) {
                var pp: IParlayProfile = $window._.find(parlayLimits.data.ParlayProfile, function (o: IParlayProfile) { return o.Teams == teams });
                if (pp != null)
                    max = pp.MaxOpen;
            }
            if (max == 0)
                max = maxteams - gameSelections.Items.length;
            return max;
        }

        ////////// PARLAY END ///////////

        ////////// TEASER START ///////////

        function setTeaserLimits(tl: ITeaserLimit): void {
            teaserLimits.data = tl;
        }

        function getTeaserLimits(): ITeaserLimit {
            return teaserLimits.data;
        }

        function allowTeaser(): boolean {
            var allow = false;
            if (teaserLimits.data != null) {
                allow = teaserLimits.data.AllowTeaser;
            }
            return allow;
        }

        function teaserMaxTeams(): number {
            var max = 0;
            if (teaserLimits.data != null) {
                max = teaserLimits.data.TeaserMaxTeams;
            }
            return max;
        }

        function teaserTeamsMaxOpenSpots(): number {
            var max = 0;
            var maxteams = (teaserMaxTeams() != 0 && teaserMaxTeams() < teaserProfileMaxTeams()) ? teaserMaxTeams() : teaserProfileMaxTeams();
            var curLegs: number = gameSelections.Items.length;
            max = maxteams - curLegs;
            if (max < 0)
                max = 0;
            return max;
        }

        function teaserMaxBet(): number {
            var max = 0;
            if (teaserLimits.data != null) {
                max = teaserLimits.data.TeaserWagerLimit;
            }
            return max;
        }

        function _indexOfTeaser(idTeaser) {
            for (var i = 0, len = teaserLimits.data.TeaserProfile.length; i < len; i++) {
                if (teaserLimits.data.TeaserProfile[i].Id == idTeaser) return i;
            }
            return -1;
        }

        function teaserProfileMaxTeams(): number {
            var max = 0;
            var idx = _indexOfTeaser(sportSelections.UrlKey());
            if (idx != -1)
                max = teaserLimits.data.TeaserProfile[idx].MaxTeams;
            return max;
        }

        function teaserProfileMinTeams(): number {
            var min = 2;
            var idx = _indexOfTeaser(sportSelections.UrlKey());
            if (idx != -1)
                min = teaserLimits.data.TeaserProfile[idx].MinTeams;
            return min;
        }

        ////////// TEASER END ///////////

        ////////// IFBET START ///////////

        function setIfbetLimits(ibl: IIfbetLimit): void {
            ifbetLimits.data = ibl;
        }

        function getIfbetLimits(): IIfbetLimit {
            return ifbetLimits.data;
        }

        function allowIfbet(): boolean {
            var allow = false;
            if (ifbetLimits.data != null) {
                allow = ifbetLimits.data.AllowIfBet;
            }
            return allow;
        }

        function ifbetMaxTeams(): number {
            var max = 0;
            if (ifbetLimits.data != null) {
                max = ifbetLimits.data.IfBetMaxTeams;
            }
            return max;
        }

        function ifbetMaxBet(): number {
            var max = 0;
            if (ifbetLimits.data != null) {
                max = ifbetLimits.data.IfBetLimit;
            }
            return max;
        }

        function allowIffers(): boolean {
            var allow = false;
            if (ifbetLimits.data != null) {
                allow = ifbetLimits.data.AllowIfBetIffers;
            }
            return allow;
        }

        ////////// IFBET END ///////////

        ////////// ACTION REVERSE START ///////////

        function setActionReverseLimits(arl: IActionReverseLimit): void {
            actionReverseLimits.data = arl;
        }

        function getActionReverseLimits(): IActionReverseLimit {
            return actionReverseLimits.data;
        }

        function allowActionReverse(): boolean {
            var allow = false;
            if (actionReverseLimits.data != null) {
                allow = actionReverseLimits.data.AllowReverse;
            }
            return allow;
        }

        function actionReverseMaxTeams(): number {
            var max = 0;
            if (actionReverseLimits.data != null) {
                max = actionReverseLimits.data.ReverseMaxTeams;
            }
            return max;
        }

        function actionReverseMaxBet(): number {
            var max = 0;
            if (actionReverseLimits.data != null) {
                max = actionReverseLimits.data.ReverseLimit;
            }
            return max;
        }

        function actionReverseGetTeamsProfile(): IActionReverseTeamProfile[] {
            var teamprofiles: IActionReverseTeamProfile[] = [];
            if (actionReverseLimits.data != null) {
                teamprofiles = actionReverseLimits.data.TeamsProfile;
            }
            return teamprofiles;
        }

        ////////// ACTION REVERSE END ///////////

        ////////// OPEN SPOTS START ///////////
        // recalculate on add/remove game
        function recalculateOpenSpotAvailable(isAdd: boolean) { //true: AddGame, false: RemoveGame
            var allow: boolean = allowOpenSpots();
            if (allow) {
                if (openSpots.getOpenSpots() > 0) {
                    if (gameSelections.Items.length == 0) {
                        setOpenSpots(0);
                    } else {
                        var maxSpots: number;
                        if (isAdd) {
                            maxSpots = maxOpenSpots();
                        } else {
                            // remove
                            maxSpots = maxOpenSpots(true);
                        }
                        // reset open spots since it depens on legs
                        if (openSpots.spots <= maxSpots) {
                            maxSpots = openSpots.spots;
                        }
                        setOpenSpots(maxSpots);
                    }
                }
            } else {
                setOpenSpots(0);
            }
        }

        // check Open Spot depending on legs
        function allowOpenSpots(): boolean {
            var allow: boolean = allowBetOpenSpots();
            if (allow) {
                // check allow on legs
                var maxOS: number = maxOpenSpots();
                //allow = (maxOS > 0 && maxOS >= openSpots.spots) ? true : false;
                allow = (maxOS > 0) ? true : false;
            }
            return allow;
        }

        // check BET default Open Spot option
        function allowBetOpenSpots(): boolean {
            var allow: boolean = false;
            var _tp = accountService.getBetSelectionType();
            // check global allow
            switch (_tp) {
                case BET_TYPES.P.type:
                case BET_TYPES.B.type:
                    if (parlayLimits.get() != null && parlayLimits.get().AllowParlayOpenSpots != null)
                        allow = parlayLimits.get().AllowParlayOpenSpots;
                    break;
                case BET_TYPES.T.type:
                    if (teaserLimits.get() != null && teaserLimits.get().AllowTeaserOpenSpots != null)
                        allow = teaserLimits.get().AllowTeaserOpenSpots;
                    break;
            }
            return allow;
        }

        // get open spots by current leg
        function maxOpenSpotsByLegs(next: boolean = false): number {
            var max: number = 0;
            var _tp = accountService.getBetSelectionType();
            var curLegs = gameSelections.Items.length + openSpots.spots;
            if (next)
                curLegs++;
            switch (_tp) {
                case BET_TYPES.P.type:
                case BET_TYPES.B.type:
                    max = parlayTeamsMaxOpenSpots(curLegs);
                    break;
                case BET_TYPES.T.type:
                    max = teaserTeamsMaxOpenSpots();
                    break;
            }
            return max;
        }

        // get open spot depending on next leg
        function maxOpenSpots(useMax: boolean = false): number {
            var max: number = 0;
            var allow: boolean = allowBetOpenSpots();
            if (allow) {
                var maxCur = maxOpenSpotsByLegs(false);
                var maxNext = maxOpenSpotsByLegs(true);
                if (maxCur >= openSpots.spots) {
                    if (maxNext > openSpots.spots) {
                        if (!useMax) {
                            max = maxNext - openSpots.spots;
                        } else {
                            max = maxNext;
                        }
                    } else {
                        openSpots.spots = maxNext; // change to max allowed
                        max = 0;
                    }
                }
            }
            return max;
        }

        function getOpenSpots(): number {
            return openSpots.spots;
        }

        function setOpenSpots(os: number): void {
            openSpots.spots = os;
        }

        function addOpenSpot(): void {
            if (openSpots.spots < 0)
                openSpots.spots = 0;
            openSpots.spots++;
        }

        function removeOpenSpot(): void {
            openSpots.spots--;
            if (openSpots.spots < 0)
                openSpots.spots = 0;
        }

        function setfillSpotData(fsData: IOpenBetDetail): void {
            openSpots.fillSpotData = fsData;
            openSpots.isFillSpot = (openSpots.fillSpotData != null) ? true : false;
            openSpots.spots = fsData.OpenSpots;
        }

        /*function isFillSpot(): boolean {
            return (openSpots.fillSpotData != null) ? true : false;
        }*/

        function clearFillSpotData(force: boolean = false) {
            var isFillSpot: boolean = openSpots.isFillSpot;
            if (!isFillSpot || force) {
                openSpots.fillSpotData = null;
                openSpots.isFillSpot = false;
            }
        }

        ////////// OPEN SPOTS END ///////////

        function setCustomerAvalableOptions(avOpt: CustomerAvailableOptions) {
            customerAvailableOptions.data = avOpt;
            // broadcast data-loaded and set permissions
            //$rootScope.$broadcast('onCustomerAvailableOptions');
            notificationService.notify_onCustomerAvailableOptions();
        }

        function setCommPermissions(data: ICustomerCommunicationPermission) {
            customerAvailableOptions.dataCommPerm = data;
            setCustomerAvalableOptions(data.Permissions);
        }

        function getCommPermissions(): ICustomerCommunicationPermission {
            return customerAvailableOptions.dataCommPerm;
        }

        function getCustomerAvalableOptions(): CustomerAvailableOptions {
            return customerAvailableOptions.data;
        }

        function setFreePlayAmt(amt: number): void {
            customerAvailableOptions.FreePlayAmount = (amt > 0) ? amt : 0;
        }

        ////////// RR START ///////////

        function _indexOfRR(numT) {
            for (var i = 0; i < gameSelections.RoundRobins.length; i++) {
                if (gameSelections.RoundRobins[i].Teams == numT)
                    return i;
            }
            return -1;
        }

        function addRR(rr: RoundRobinSel) {
            var i = _indexOfRR(rr.Teams)
            if (i == -1)
                gameSelections.RoundRobins.push(rr);
        }

        function chgAmtRR(rr: RoundRobinSel) {
            var i = _indexOfRR(rr.Teams)
            if (i != -1)
                gameSelections.RoundRobins[i].Amount = rr.Amount;
        }

        function clearRR() {
            gameSelections.RoundRobins.splice(0, gameSelections.RoundRobins.length);
        }

        ////////// RR END ///////////

        ////////// PITCHER START ///////////

        function getPitcherSettings() {
            return pitcherSelection.settings;
        }

        function setPitcherSettings(s: IPitcherSetting) {
            pitcherSelection.settings = s;
        }
        ////////// PITCHER END ///////////

        function gotoStateConfirm(title, state, params) {
            var deferred = $q.defer();
            var rst: boolean = false;
            if (title == null || title == "")
                title = "Atention";
            if (gameSelections.Items.length == 0) {
                rst = true;
                if (params == null) {
                    $state.go(state, {}, { reload: true });
                } else {
                    $state.go(state, params, { reload: true });
                }
                deferred.resolve(true);
            } else {
                $mdDialog.show({
                   /* $mdDialog.confirm()
                        .title(title)
                        .textContent("You have unconfirmed selections. Continue?")
                        .ok("Confirm")
                        .cancel("Cancel")*/
                        controller: 'HomeDialogController',
                        controllerAs: 'vm',
                        templateUrl: 'app/core/components/toolbars/home-confirm-dialog.tmpl.html',
                        locals: {
                            title: title
                        },
                        fullscreen: false,
                        focusOnOpen: false
                })
                .then(function () {
                    deferred.resolve(true);
                    ClearGame();
                    if (params == null) {
                        $state.go(state, {}, { reload: true });
                    } else {
                        $state.go(state, params, { reload: true });
                    }
                }, 
                function () {
                    deferred.resolve(false);
                });
            }
            return deferred.promise;
        }
    }

})();

/**
 * GameSelectionItem implements IGameSelectionItem
 */
class GameSelectionItem implements IGameSelectionItem {
    key: string;
    amount: number;
    lineDetail: any;
    period: number;
    pitcherData: any;
    calcType: string;
    lines: ILineObj[];
}